import 'src/components/shared/CopyText.css'
import { useState } from 'react'
import { ClipboardDocumentIcon } from '@heroicons/react/24/outline'
import { CheckCircleIcon } from '@heroicons/react/24/solid'

type Props = {
  copyText: string
  text: React.ReactNode
  className?: string
}

export const CopyText: React.FC<Props> = ({
                                            copyText,
                                            text,
                                            className,
                                          }) => {
  const [copied, setCopied] = useState(false)

  const handleCopy = () => {
    navigator.clipboard.writeText(copyText)
    setCopied(true)

    // Revert back to the copy icon after 2 seconds
    setTimeout(() => {
      setCopied(false)
    }, 2000)
  }

  const iconProps = {
    onClick: handleCopy,
    style: { cursor: 'pointer' },
    className: 'copy-icon'
  }

  return (
    <div className={`copy-text-container ${className || ''}`}>
      {text}
      {copied ? <CheckCircleIcon {...iconProps} /> : <ClipboardDocumentIcon {...iconProps} />}
    </div>
  )
}
